import { push } from 'connected-react-router';
import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getTicketById(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_RESERVE_TICKET_DETAIL_REQUEST,
			payload: { loadingTicketDetail: true }
		});

		//Get all tickets
		const response = await API.ticket.getTicketById({ id });

		if(response.meta.code !== 200){
			dispatch({
				type: ActionTypes.GET_RESERVE_TICKET_DETAIL_ERROR,
				payload: {
					meta: response.meta,
					loadingTicketDetail: false
				}
			});
			return;
		}

		const { ticket } = response.data;

		dispatch({
			type: ActionTypes.GET_RESERVE_TICKET_DETAIL_SUCCESS,
			payload: {
				ticket,
				loadingTicketDetail: false
			}
		});
	};
}

export function getMachines(query) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_RESERVE_MACHINE_PAGE_REQUEST,
			payload: { loadingMachines: true }
		});

		//Get all machines
		const response = await API.machine.getMachines(query);

		if(response.meta.code !== 200){
			dispatch({
				type: ActionTypes.GET_RESERVE_MACHINE_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loadingMachines: false
				}
			});
			return;
		}

		const { machines } = response.data;

		dispatch({
			type: ActionTypes.GET_RESERVE_MACHINE_PAGE_SUCCESS,
			payload: {
				machines,
				loadingMachines: false
			}
		});
	};
}

export function updateTicketById({ selected_machine_id, action }) {
	return async (dispatch, getState) => {
		const { ticket } = getState().reserveMachinePageReducer;

		dispatch({
			type: ActionTypes.SUBMIT_RESERVE_MACHINE_PAGE_REQUEST,
			payload: { loadingSubmit: true }
		});

		const body = {
			ticket: {
				selected_machine_id,
				action,
				updated_at: ticket.updated_at
			}
		};

		const response = await API.ticket.updateTicketById(ticket._id, body);

		if(response.meta.code !== 200){
			dispatch({
				type: ActionTypes.SUBMIT_RESERVE_MACHINE_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});
			return;
		}

		const { ticket: newTicket } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_RESERVE_MACHINE_PAGE_SUCCESS,
			payload: {
				ticket: newTicket,
				meta: response.meta,
				loadingSubmit: false
			}
		});
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_RESERVE_MACHINE_PAGE_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_RESERVE_MACHINE_PAGE
		});
	};
}
